'use client'
import type { Data } from '@repo/strapi'
import { useTranslations } from 'next-intl'
import AppLink from '@/components/elementary/AppLink'
import { ArrowRight } from '@/components/icons/ArrowRight'
import { BasicImage } from '@/components/page-builder/components/BasicImage'
import Heading from '@/components/typography/Heading'
import { cn } from '@/lib/styles'
import { CASE_STUDIES_FILTERS_TEST_IDS } from '@/lib/test-ids'
import { getCaseStudyLink } from '@/utils/links'

export function CaseStudyCard(props: {
	slug: string | null | undefined
	title: string | null | undefined
	primaryImage: Data.Component<'utilities.basic-image'> | null | undefined
	previewImage: Data.Component<'utilities.basic-image'> | null | undefined
	logo: Data.Component<'utilities.basic-image'> | null | undefined
	bgClassName?: string
}) {
	const { slug, title, primaryImage, previewImage, logo, bgClassName } = props
	const t = useTranslations('CaseStudyCard')
	return (
		<div
			className={cn(
				'flex flex-col gap-4 flex-1 justify-between',
				bgClassName && 'p-5 rounded-xl',
				bgClassName,
			)}
		>
			<div className="flex flex-col gap-4">
				{logo && (
					<div className="h-7 lg:h-9 flex items-center">
						<BasicImage
							component={logo}
							width={100}
							height={36}
							className="object-contain w-full object-left"
						/>
					</div>
				)}
				{primaryImage || previewImage ? (
					<div
						className={cn(
							'relative h-67.25 w-full rounded-xl border overflow-hidden',
							!bgClassName && 'border-brand-black ',
						)}
					>
						<BasicImage component={previewImage ?? primaryImage} fill className="object-cover" />
					</div>
				) : null}
				<Heading tag="h3" fontSize="headingMedium">
					{title}
				</Heading>
			</div>
			{slug && (
				<AppLink
					href={getCaseStudyLink(slug)}
					variant="tertiaryLink"
					className="no-underline font-semibold w-fit"
					data-test-id={CASE_STUDIES_FILTERS_TEST_IDS.CASE_STUDY_LINK}
					iconEnd={<ArrowRight className="size-5" />}
				>
					{t('readStory')} <span className="sr-only">{title}</span>
				</AppLink>
			)}
		</div>
	)
}
